import { Slot } from "core/types/index";

/* eslint-disable import-x/no-duplicates -- locales live under date-fns/locale but the rule resolves both paths to the same module */
import { format } from "date-fns";
import { enGB, sv, da, nl, nb, enUS } from "date-fns/locale";
/* eslint-enable import-x/no-duplicates */

export type ClipboardSlot = Pick<Slot, "status" | "templateId" | "startsAt">;

const localeMap = {
  en: enGB,
  sv: sv,
  da: da,
  nl: nl,
  no: nb,
  nb: nb,
  nn: nb,
  "en-GB": enGB,
  "en-US": enUS,
} as const;

type Locale = keyof typeof localeMap;

const formatDate = (date: Date, locale: string) => {
  if (locale in localeMap) {
    return format(date, "P", { locale: localeMap[locale as Locale] });
  }
  return format(date, "P", { locale: sv });
};

export const formatSlotsForClipboard = (slots: ClipboardSlot[]) => {
  const userLocale = navigator.language ?? "sv";

  // Group the slots per day
  const groupedByDate = slots.reduce(
    (result, slot) => {
      const dateString = formatDate(new Date(slot.startsAt * 1000), userLocale);
      const updatedResult = { ...result };
      updatedResult[dateString] = updatedResult[dateString] || [];
      updatedResult[dateString].push(slot);
      return updatedResult;
    },
    {} as { [date: string]: ClipboardSlot[] },
  );

  // format each date
  let formattedSlots = "";
  Object.entries(groupedByDate).forEach(([, slotsArray]) => {
    const date = new Date(slotsArray[0].startsAt * 1000);
    const dateString = formatDate(date, userLocale);
    formattedSlots += `\n${dateString}`;
    // Format each slot within the date
    slotsArray.forEach((slot) => {
      const startAtDate = new Date(slot.startsAt * 1000);
      const startsAtMinutes = startAtDate.getMinutes();
      const formattedStartsAtMinutes =
        startsAtMinutes < 10 ? `0${startsAtMinutes}` : startsAtMinutes;
      formattedSlots += `\n  \u2022 ${startAtDate.getHours()}:${formattedStartsAtMinutes}`;
    });
  });

  return `${formattedSlots}\n`;
};
